import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export class IndexScrollMask {
  constructor() {
    this.el = document.querySelector('.p-index_message__scroll')
    this.maskRect = document.getElementById('maskRect')
    this.nextSection = document.querySelector('.p-index_job-overview')

    if (!this.el || !this.maskRect || !this.nextSection) return

    // スマホは無効化（768px 未満）
    if (window.innerWidth < 768) return

    this.init()
    window.addEventListener('resize', this.onResize.bind(this))
  }

  getStartValues() {
    const startWidth = window.innerWidth * 0.7
    const startHeight = 434
    const endWidth = 1600
    const endHeight = 900

    const startX = (1600 - startWidth) / 2
    const startY = (900 - startHeight) / 2
    const endX = 0
    const endY = 0

    return { startWidth, startHeight, endWidth, endHeight, startX, startY, endX, endY }
  }

  init() {
    // ScrollTrigger をすべて削除
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill())

    this.values = this.getStartValues()

    const { startWidth, startHeight, startX, startY } = this.values

    // 初期サイズを設定
    gsap.set(this.maskRect, {
      attr: {
        width: startWidth,
        height: startHeight,
        x: startX,
        y: startY,
      },
    })

    // スクロールに合わせてマスク拡大アニメーション
    this.scrollTrigger = ScrollTrigger.create({
      trigger: this.el,
      start: 'top top',
      end: '+=100%',
      scrub: true,
      pin: true,
      pinSpacing: true,
      onUpdate: (self) => this.updateMask(self.progress),
    })

    // 次のセクションに入ったときのマスク位置調整
    this.nextSectionTrigger = ScrollTrigger.create({
      trigger: this.nextSection,
      start: 'top top',
      onEnter: () => this.adjustMaskAtNextSection(),
    })
  }

  updateMask(progress) {
    if (!this.maskRect || !this.maskRect.ownerSVGElement) return

    const { startWidth, endWidth, startHeight, endHeight, startX, endX, startY, endY } = this.values

    gsap.set(this.maskRect, {
      attr: {
        width: gsap.utils.interpolate(startWidth, endWidth, progress),
        height: gsap.utils.interpolate(startHeight, endHeight, progress),
        x: gsap.utils.interpolate(startX, endX, progress),
        y: gsap.utils.interpolate(startY, endY, progress),
      },
    })
  }

  adjustMaskAtNextSection() {
    if (!this.maskRect || !this.maskRect.ownerSVGElement) return

    const { startWidth, endWidth, startHeight, endHeight } = this.values

    const maskWidth = gsap.utils.interpolate(startWidth, endWidth, 1)
    const maskHeight = gsap.utils.interpolate(startHeight, endHeight, 1)
    const offsetX = (window.innerWidth - maskWidth) / 2
    const offsetY = 50

    gsap.set(this.maskRect, {
      attr: {
        width: maskWidth,
        height: maskHeight,
        x: offsetX,
        y: offsetY,
      },
    })
  }

  onResize() {
    // スマホは無効（ScrollTrigger を全削除）
    if (window.innerWidth < 768) {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
      return
    }

    // PCサイズなら再初期化（再計算して ScrollTrigger を再生成）
    ScrollTrigger.getAll().forEach((trigger) => trigger.kill())
    this.init()
  }
}
